import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].GET_WORK_ORDERS_PRODUCTS]: {
		url: '/company/:companyId/work_orders/:workOrderId/products/',
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].GET_WORK_ORDERS_PRODUCT]: {
		url: '/company/:companyId/work_orders/:workOrderId/products/:productId/',
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].CREATE_WORK_ORDERS_PRODUCT]: {
		url: '/company/:companyId/work_orders/:workOrderId/products/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].PUT_WORK_ORDERS_PRODUCT]: {
		url: '/company/:companyId/work_orders/:workOrderId/products/:productId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].PATCH_WORK_ORDERS_PRODUCT]: {
		url: '/company/:companyId/work_orders/:workOrderId/products/:productId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].DELETE_WORK_ORDERS_PRODUCT]: {
		url: '/company/:companyId/work_orders/:workOrderId/products/:productId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}